// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"2025-05-30T15:28:47.423Z"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { envs } from '@/app/utils/envs';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: envs.businessEnv,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  integrations: [Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true })],
  beforeSend(event) {
    // Completely remove the cookie header from the request
    if (event.request?.headers?.cookie) {
      delete event.request.headers.cookie;
    }

    // Ignore specific known benign errors
    const ignoredErrors = [
      `is not an object (evaluating 'window.webkit.messageHandlers')'`,
      `Cannot read properties of null (reading 'touches')`,
      `undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')`,
      `Cannot read properties of undefined (reading 'IS')`,
    ];

    // Ignore errors based on the message content
    if (event.exception?.values?.some((exception) => ignoredErrors.includes(exception.value || ''))) {
      return null; // Returning null drops the event
    }

    return event;
  },

  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
